<template>
  <el-tabs tab-position="left" v-model="tabActive">
    <el-tab-pane label="Lbq" name="Lbq">
      <MaintainTabData :data="allData.Lbq"/>
    </el-tab-pane>
    <el-tab-pane label="Endless" name="Endless">
      <MaintainTabData :data="allData.Endless"/>
    </el-tab-pane>
    <el-tab-pane label="RaidbossGrand" name="RaidbossGrand">
      <MaintainTabData :data="allData.RbGrand"/>
    </el-tab-pane>
    <el-tab-pane label="RaidbossLittle" name="RaidbossLittle">
      <MaintainTabData :data="allData.RbLittle"/>
    </el-tab-pane>
    <el-tab-pane label="Versus" name="Versus">
      <MaintainTabData :data="allData.Versus"/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>

import MaintainTabData from "./MaintainTabData.vue"

function noop() {}

export default {
  name: "event",
  components: {
    MaintainTabData
  },
  props: {
    allData : {},
  },
  data: () => {
    return {
      tabActive: "Lbq",
    }
  },
  methods: {
  }
};

</script>